import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import CustomLoadingScreen from "./CustomLoadingScreen";

const ProtectedRoute = ({ children }) => {
  const { user } = useUserAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      // If user is null (not yet loaded), keep loading
      if (user === null) {
        return;
      }
      
      // If no user, immediately set as not authenticated
      if (!user) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        // Force token refresh - this will throw an error if the token is truly expired
        const token = await user.token;
        if (token) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, [user]);

  // Show loading while checking authentication
  if (isLoading) {
    return <CustomLoadingScreen />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;